const DISMISSED_KEY = 'tandemone.install.dismissed'

export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false
  const nav = navigator as Navigator & { standalone?: boolean }
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    nav.standalone === true
  )
}

/* ipados reports itself as a mac, so touch points break the tie. */
export function isIosBrowser(): boolean {
  if (typeof navigator === 'undefined') return false
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

export function isInstallDismissed(): boolean {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) !== null
  } catch {
    return false
  }
}

export function dismissInstall(): void {
  try {
    window.localStorage.setItem(DISMISSED_KEY, '1')
  } catch {
    /* private mode: the row simply comes back next visit. */
  }
}
